import React from 'react';
import { Modal } from 'antd';

interface ConfirmDeleteModalProps {
  open: boolean;
  title: string;
  description: string;
  onOk: () => void;
  onCancel: () => void;
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  open,
  title,
  description,
  onOk,
  onCancel,
}) => {
  return (
    <Modal
      title={title}
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      okText="Delete"
      okType="danger"
      cancelText="Cancel"
    >
      <p>{description}</p>
    </Modal>
  );
};

export default ConfirmDeleteModal; 